import { config, isFetchError } from '@grafana/runtime';

"use strict";
const getAPINamespace = () => config.namespace;
const getAPIBaseURL = (group, version) => {
  return `/apis/${group}/${version}/namespaces/${getAPINamespace()}`;
};
const normalizeError = (e) => {
  if (!e) {
    return "Unknown error";
  }
  if (typeof e === "object") {
    if ("data" in e && e.data && typeof e.data === "object" && "message" in e.data) {
      return String(e.data.message);
    }
    if ("message" in e) {
      return String(e.message);
    }
    if ("error" in e) {
      if (e.error instanceof Error) {
        return e.error.message;
      } else if (isFetchError(e.error)) {
        if (e.error.data && typeof e.error.data === "object" && "message" in e.error.data) {
          return String(e.error.data.message);
        }
        if (Array.isArray(e.error.data.errors) && e.error.data.errors.length) {
          return e.error.data.errors.join("\n");
        }
      }
    }
  }
  if (e instanceof Error) {
    return e.message;
  }
  return String(e);
};
function handleRequestError(error) {
  if (isFetchError(error) || error instanceof Error) {
    return { error };
  } else {
    return { error: new Error("Unknown error") };
  }
}

export { getAPIBaseURL, getAPINamespace, handleRequestError, normalizeError };
//# sourceMappingURL=utils.mjs.map
